/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MoveLabelsToSkillsInput = {
    labelIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type moveLabelsToSkillsMutationVariables = {
    input: MoveLabelsToSkillsInput;
};
export type moveLabelsToSkillsMutationResponse = {
    readonly moveLabelsToSkills: {
        readonly deletedLabelIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type moveLabelsToSkillsMutation = {
    readonly response: moveLabelsToSkillsMutationResponse;
    readonly variables: moveLabelsToSkillsMutationVariables;
};



/*
mutation moveLabelsToSkillsMutation(
  $input: MoveLabelsToSkillsInput!
) {
  moveLabelsToSkills(input: $input) {
    deletedLabelIds
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MoveLabelsToSkillsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoveLabelsToSkillsPayload",
    "kind": "LinkedField",
    "name": "moveLabelsToSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "moveLabelsToSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation moveLabelsToSkillsMutation(\n  $input: MoveLabelsToSkillsInput!\n) {\n  moveLabelsToSkills(input: $input) {\n    deletedLabelIds\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c89d7ad28c0f9506cfeaac45a1521cc5';
export default node;
